<div class="dialog" role="document" aria-labelledby="add-staff-title">
  <div class="dialog-header">
    <span class="dialog-title" id="add-staff-title">Add staff member</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" novalidate (ngSubmit)="submit()">
    <div class="field-row">
      <div class="field">
        <label class="field-label" for="staff-user-name">Username <span aria-hidden="true">*</span></label>
        <input id="staff-user-name" type="text" class="text-box-active" autocomplete="username" formControlName="userName" />
        @if(usernameCheck.message){
        <span
          class="field-message"
          [class.field-error]="usernameCheck.status === 'taken' || usernameCheck.status === 'short'"
          [class.field-success]="usernameCheck.status === 'available'"
        >
          {{ usernameCheck.message }}
        </span>
        }
      </div>
      <div class="field">
        <label class="field-label" for="staff-family-code">Family code <span aria-hidden="true">*</span></label>
        <input
          id="staff-family-code"
          type="text"
          class="text-box-active"
          autocomplete="off"
          inputmode="numeric"
          maxlength="12"
          formControlName="familyCode"
          (input)="onFamilyCodeInput()"
        />
        @if(memberLookup.isLoading){ <span class="field-message">Finding members…</span> }
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" id="staff-name-label">Name <span aria-hidden="true">*</span></label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            aria-labelledby="staff-name-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="memUuid"
            [placeholder]="memberLookup.loaded ? 'Select the person' : 'Enter the family code first'"
            (selectionChange)="onMemberPick($event.value)"
          >
            @for(m of memberLookup.members; track $index){
            <mat-option [value]="m.memUuid" [disabled]="!m.memUuid">
              {{ m.fullName }}
            </mat-option>
            } @empty {
            <mat-option [value]="''" disabled>
              {{ memberLookup.loaded ? 'No members found.' : 'Enter the 12-digit family code.' }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if(memberLookup.pickMessage){
        <span class="field-message" [class.field-error]="memberLookup.pickStatus === 'taken'">
          {{ memberLookup.pickMessage }}
        </span>
        }
      </div>
      <div class="field">
        <label class="field-label" id="staff-role-label">Role <span aria-hidden="true">*</span></label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            aria-labelledby="staff-role-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="roleKey"
          >
            @for(r of roles; track r.key){
            <mat-option [value]="r.key">{{ r.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if(isVolunteer){
    <div class="field-row">
      <div class="field">
        <label class="field-label" for="staff-valid-until">Access valid until <span aria-hidden="true">*</span></label>
        <input id="staff-valid-until" type="date" class="text-box-active" formControlName="validUntil" />
      </div>
    </div>
    }

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="staff-mobile-number">Mobile number</label>
        <input id="staff-mobile-number" type="tel" class="text-box-active" autocomplete="tel" formControlName="mobileNumber" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="staff-email">Email</label>
        <input id="staff-email" type="email" class="text-box-active" autocomplete="email" formControlName="emailId" />
      </div>
      <div class="field">
        <label class="field-label" for="staff-identity-number">Identity number</label>
        <input id="staff-identity-number" type="text" class="text-box-active" autocomplete="off" formControlName="identityNumber" />
      </div>
    </div>

    <div class="dialog-actions">
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="close()">Close</button>
      <button type="submit" class="ac-primary-btn" [disabled]="form.invalid || isLoading">Add staff</button>
    </div>
  </form>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
